<mat-toolbar *ngIf="!hideNav" class="custom-toolbar mat-elevation-z2">
  <!-- Brand / Logo -->
  <a [routerLink]="['/']" class="brand-link custom-brand-link" tabindex="0">
    <span class="brand-title custom-brand-title">Upstanding Citizen</span>
    <span class="beta-pill">Beta</span>
  </a>

  <span class="navigation-spacer"></span>

  <!-- Right-hand user area: skeleton while loading, then profile/login -->
  <ng-container *ngIf="isProfileLoading; else showNavContent">
    <div class="profile-skeleton-container">
      <app-skeleton [width]="40" [height]="40" [borderRadius]="20"></app-skeleton>
    </div>
  </ng-container>

  <ng-template #showNavContent>
    <ng-container *ngIf="isLoggedIn$ | async; else showLogin">
      <!-- Profile Menu Trigger -->
      <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="profile-icon">
        <ng-container *ngIf="profileImageUrl && profileImageUrl.trim() !== ''; else showMenuIcon">
          <img [src]="profileImageUrl" alt="Profile" class="profile-image" />
        </ng-container>
        <ng-template #showMenuIcon>
          <mat-icon>menu</mat-icon>
        </ng-template>
      </button>

      <!-- Profile Menu -->
      <mat-menu #profileMenu="matMenu">
        <!-- Personal -->
        <div class="menu-group-label">Personal</div>
        <button *ngIf="user?.is_model" mat-menu-item (click)="onViewMyProfileClick()">
          <mat-icon>person</mat-icon>
          <span>My Profile</span>
        </button>
        <button mat-menu-item (click)="onProfileClick()">
          <mat-icon>account_circle</mat-icon>
          <span>Edit Profile</span>
        </button>
        <button *ngIf="(isLoggedIn$ | async)" mat-menu-item [routerLink]="['/my-likes']">
          <mat-icon>favorite</mat-icon>
          <span>My Likes</span>
        </button>

        <mat-divider></mat-divider>

        <!-- Discovery -->
        <div class="menu-group-label">Discovery</div>
        <button mat-menu-item [routerLink]="['/models']">
          <mat-icon>groups</mat-icon>
          <span>Browse Models</span>
        </button>
        <button mat-menu-item [routerLink]="['/media']">
          <mat-icon>photo_library</mat-icon>
          <span>Browse Media</span>
        </button>

        <mat-divider></mat-divider>

        <!-- Creator Tools -->
        <div class="menu-group-label">Creator Tools</div>
        <button *ngIf="user?.is_model" mat-menu-item (click)="onContentManagerClick()">
          <mat-icon>dashboard_customize</mat-icon>
          <span>Content Manager</span>
        </button>
        <!-- Upgrade option for client users who are not yet models -->
        <button *ngIf="user && !user.is_model" mat-menu-item (click)="onBecomeModel()" [disabled]="isUpgrading">
          <mat-icon>stars</mat-icon>
          <span>Become a Model</span>
        </button>
        <button *ngIf="(isLoggedIn$ | async) && user?.referral_code" mat-menu-item (click)="onShareReferral()">
          <mat-icon>share</mat-icon>
          <span>Share Referral</span>
        </button>

        <mat-divider></mat-divider>

        <!-- System -->
        <button mat-menu-item (click)="onLogout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </ng-container>

    <!-- Login button when logged out -->
    <ng-template #showLogin>
      <a mat-flat-button class="login-btn" [routerLink]="['/login']">Login</a>
    </ng-template>
  </ng-template>
</mat-toolbar>
